import PropTypes from 'prop-types';

import InfoBlock from '../InfoBlock';

import styles from './index.styl';


function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export default function ReleaseInfo(props) {
  const {
    minPrice,
    offersUrl,
    brandSlug,
    topicsText,
    modificationsText,
    url,
    parentProps,
  } = props;

  return (
    <div className={styles.numericInfo}>
      <InfoBlock
        caption='В каталоге'
        to={url}
        parentProps={parentProps}
      >
        {modificationsText}
      </InfoBlock>
      {!!minPrice && (
        <InfoBlock
          caption='В продаже'
          to={`https://quto.ru${offersUrl}`}
          parentProps={parentProps}
        >
          от {numberWithSpaces(minPrice)}
        </InfoBlock>
      )}
      <InfoBlock
        caption='В журнале'
        to={`https://quto.ru/journal/label/${brandSlug}`}
        parentProps={parentProps}
      >
        {topicsText}
      </InfoBlock>
    </div>
  );
}

ReleaseInfo.propTypes = {
  minPrice: PropTypes.number,
  topicsText: PropTypes.string,
  offersUrl: PropTypes.string,
  url: PropTypes.string,
  brandSlug: PropTypes.string,
  modificationsText: PropTypes.string,
  parentProps: PropTypes.object,
};
